// Lightweight API helpers for users
// Supports both legacy paginated endpoints and new ID-based endpoints.

import {callAjax} from "../auth/ApiAuth";

const BASE = process.env.REACT_APP_BASE_URL;

const buildQuery = (params = {}) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

// GET /api/students/?page=1&page_size=10&email=...&pk=...
export const getPaginatedStudents = async ({
  email,
  pk,
  ...rest
} = {}) => {
  const query = buildQuery({email, pk, ...rest });
  const url = `${BASE}/api/students/${query ? `?${query}` : ""}`;
  return callAjax(url);
};

// GET /api/teachers/?page=1&page_size=10&email=...&pk=...
export const getPaginatedTeachers = async ({
  page = 1,
  page_size = 10,
  email,
  pk,
  ...rest
} = {}) => {
  const query = buildQuery({email, pk, ...rest });
  const url = `${BASE}/api/teachers/${query ? `?${query}` : ""}`;
  return callAjax(url);
};

export const getStudentIds = async (options = {}) => {
  const query = buildQuery(options);
  const url = `${BASE}/api/students/ids/${query ? `?${query}` : ""}`;
  return callAjax(url);
};

export const getTeacherIds = async (options = {}) => {
  const query = buildQuery(options);
  const url = `${BASE}/api/teachers/ids/${query ? `?${query}` : ""}`;
  return callAjax(url);
};

export const getStudentsByIds = async (ids = []) => {
  if (!Array.isArray(ids) || ids.length === 0) return [];
  const cleanIds = cleanUserIds(ids)
  const query = cleanIds.map((id) => `ids=${encodeURIComponent(id)}`).join('&');
  const url = `${BASE}/api/students/${query ? `?${query}` : ""}`;
  return callAjax(url);
};

export const getTeachersByIds = async (ids = []) => {
  if (!Array.isArray(ids) || ids.length === 0) return [];
  const cleanIds = cleanUserIds(ids)
  const query = cleanIds.map((id) => `ids=${encodeURIComponent(id)}`).join('&');
  const url = `${BASE}/api/teachers/${query ? `?${query}` : ""}`;
  return callAjax(url);
};

const cleanUserIds = (ids) => {
  return ids
      .map((v) => (typeof v === 'string' ? v.trim() : v))
      .map((v) => Number(v))
      .filter((v) => Number.isInteger(v));
};

const usersApi = {
  getPaginatedStudents,
  getPaginatedTeachers,
  getStudentIds,
  getTeacherIds,
  getStudentsByIds,
  getTeachersByIds,
};

export default usersApi;
